import { render, staticRenderFns } from "./SuspendedEntityModal.vue?vue&type=template&id=157dd1b0&scoped=true&"
import script from "./SuspendedEntityModal.vue?vue&type=script&lang=js&"
export * from "./SuspendedEntityModal.vue?vue&type=script&lang=js&"
import style0 from "./SuspendedEntityModal.vue?vue&type=style&index=0&id=157dd1b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157dd1b0",
  null
  
)

export default component.exports